import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, Switch, TextField, Toolbar, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import FuseUtils from '@fuse/utils/FuseUtils';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import customStyles from 'app/shared-components/SelectCustomStyle';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../design-studio/store/actions';
import { DateTimePicker, StaticDateTimePicker, TimePicker } from '@mui/x-date-pickers';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import moment from 'moment';
import { useForm } from '@fuse/hooks';
import Thankyou from './Thankyou';
import { useState } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import OAuthService from 'src/app/auth/services/oAuthService';
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import { useNavigate } from 'react-router-dom';

const defaultFormState = {
    id: FuseUtils.generateGUID(),
    start: moment().format('yyyy-MM-dd hh:mm:ss aa'),
    end: moment().format('yyyy-MM-dd hh:mm:ss aa'),
    title: 'Site visit',
    desc: '',
};

const MeetingDialog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const eventDialog = useSelector(({ dSCalendarApp }) => dSCalendarApp.events.eventDialog);
    const dsTask = JSON.parse(localStorage.getItem('dsTask'))
    const [open, setOpen] = useState(false);
    const [type, setType] = useState(eventDialog.type);
    const { form, handleChange, setForm, setInForm } = useForm(defaultFormState);
    const handleClose = () => {
        closeComposeDialog();
        setOpen(false)
    }

    function closeComposeDialog() {
        return eventDialog.type === 'edit'
            ? dispatch(Actions.closeEditEventDialog())
            : dispatch(Actions.closeNewEventDialog());
    }

    useEffect(() => {
        if (eventDialog.props.open) {
            setType(eventDialog.type);
            setForm({ ...eventDialog.data })
            // setForm(defaultFormState)
        }
    }, [eventDialog.props.open])


    const handleSubmit = async (event) => {
        event.preventDefault();

        if (dsTask) {
            const model = {
                ...dsTask,
                scheduledStartDate: moment(form?.start).toISOString(),
                scheduledEndDate: moment(form?.end).toISOString(),
                location: form?.desc,
                description: !form.title ? 'Site visit' : form?.title,
                isDsStatusPassForNextState: true,
                assignees: [],
                comments: {
                    additionalProp1: [],
                    additionalProp2: [],
                    additionalProp3: []
                },
                // kitchenQuantities: [],
                // spacePlans: []
            }

            await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${model?.dsTaskId}`, model)
                .then(async (res) => {
                    const data = {
                        ...res?.data,
                        isDsLifeCyclePassForNextState: true
                    }
                    await OAuthService.putData(`${process.env.REACT_APP_DESIGN_STUDIO_API_KEY_URL}${oAuthServiceConfig.dsTaskAssignment}/${model?.dsTaskId}`, data)
                    setOpen(true)
                    setTimeout(() => {
                        setOpen(false)
                        localStorage.removeItem('dsTask')
                        localStorage.removeItem('backAction')
                        navigate('/design-studio-dashboard')
                    }, 3000)
                })
                .catch((err) => console.log(err));
        }
        closeComposeDialog();

    }

    return (
        <>
            <Dialog {...eventDialog.props}
                onClose={closeComposeDialog}
                fullWidth maxWidth="xs" component="form">
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                            Type and Slot selection
                            {/* {eventDialog.type === 'new' ? 'New Holiday' : 'Edit Holiday'} */}
                        </Typography>
                        <IconButton onClick={handleClose}>
                            <Icon>close</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>

                <form>
                    <DialogContent classes={{ root: 'p-16 pb-0 sm:p-24 sm:pb-0' }}>
                        <Typography>SITE VISIT
                            <Switch
                                // classes={switchStyles}
                                checked={form?.title == 'Request a meeting'}
                                onChange={e => setInForm('title', e.target.checked ? 'Request a meeting' : 'Site visit')}
                            />
                            {/* <br /> */}
                            REQUEST A MEETING</Typography>
                        <DesktopDateTimePicker
                            label="Start"
                            inputFormat="yyyy-MM-dd hh:mm:ss aa"
                            value={form.start}
                            onChange={date => setInForm('start', date)}
                            renderInput={(params) => <TextField {...params} className="mt-8 mb-16" fullWidth />}
                        />
                        <DesktopDateTimePicker
                            label="End"
                            inputFormat="yyyy-MM-dd hh:mm:ss aa"
                            value={form.end}
                            onChange={date => setInForm('end', date)}
                            renderInput={(params) => <TextField {...params} className="mt-8 mb-16" fullWidth />}
                        />
                        <TextField
                            className="mt-8 mb-16"
                            id="desc"
                            label="Location"
                            type="text"
                            name="desc"
                            value={form.desc}
                            onChange={e => setInForm('desc', e.target.value)}
                            variant="outlined"
                            fullWidth
                        />
                    </DialogContent>

                    <DialogActions className="justify-between px-8 sm:px-16">
                        <Button
                            onClick={handleSubmit}
                            variant="contained" color="primary" type="submit">
                            Add
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
            <Dialog
                fullWidth={true}
                maxWidth={'sm'}
                onClose={handleClose}
                open={open}
            // {...other}
            >
                <DialogTitle>
                    <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                            <Button onClick={handleClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent dividers>
                    <Thankyou requestId={dsTask?.dsTaskId} />
                </DialogContent>
            </Dialog>
        </>
    );
}

export default MeetingDialog